var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pre',{staticClass:"demo-source"},[_c('code',{class:_vm.languageClass},[_vm._v("\n"),_vm._t("default",[_vm._v("\n")]),_vm._v("\n")],2),_vm._v("\n")])}
var staticRenderFns = []
export { render, staticRenderFns }